export { default, default as InLineNotification } from './InLineNotification'
export { default as inLineNotificationTheme } from './themes/InLineNotification.theme'
export * as InLineNotificationStyles from './styles/InLineNotification.style'

export type { InLineNotificationProps } from './InLineNotification.types'
export type { AppearanceKeys, InLineNotificationTheme } from './themes/InLineNotification.theme.types'
export type { StyledInLineNotificationProps } from './styles/InLineNotification.style.types'
